import React from 'react';
import "./Contact.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { Col, Container, Row } from 'reactstrap';

const Contact = () => {
  return (
    <div className='page__wrapper'>
        <Navbar />
        <div className='contact__container'>
            <div className='contact__info'>
                <Container>
                    <Row>
                        <Col lg='12' className='mb-5'>
                            <h2>Get In Touch</h2>
                        </Col>
                        <Col lg='6' md='6'>
                            <div className="contact__info-container  d-flex align-items-center gap-5">
                                <div className="single__info-box w-50">
                                    <h6>Social Media</h6>
                                    <p>Tiktok: @alexmenswearhq</p>
                                    <p>Instagram: @alexmenswearhq</p>
                                </div>
                                <div className="single__info-box w-50 ">
                                    <h6>Phone</h6>
                                    <p>+1-858-361-8425</p>
                                </div>
                            </div>
                            <div className="contact__info-container d-flex align-items-center gap-5">
                                <div className="single__info-box w-50">
                                    <h6>Email</h6>
                                    <a href = "mailto:support@alexmenswear.com?subject = Support&body = My Message">
                                        support@alexmenswear.com
                                    </a>
                                </div>
                                <div className="single__info-box w-50">
                                    <h6>Headquarters</h6>
                                    <p>San Diego, California</p>
                                </div>
                            </div>
                            <div className="contact__info-container d-flex align-items-center gap-5">
                               
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
        <Footer />
    </div>  
  )
}

export default Contact
